var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "lesson-detail" },
    [
      _c(_setup.ResponsiveModal, {
        ref: "responsiveModal",
        attrs: {
          title: _setup.getTitle,
          expandCover: _setup.expandCover,
          fullscreen: "",
          color: "accent",
        },
        on: {
          reset: function ($event) {
            return _setup.emit("reset")
          },
        },
        scopedSlots: _vm._u([
          {
            key: "subtitle",
            fn: function () {
              return [
                _c(
                  "v-list",
                  {
                    staticClass: "transparent lesson-detail-list pb-0",
                    attrs: { dense: "" },
                  },
                  _vm._l(_setup.getDetails, function (item) {
                    return _c(
                      "v-list-item",
                      {
                        key: item.text,
                        staticClass: "lesson-detail-items soli-text-shadow",
                      },
                      [
                        _c(
                          "v-icon",
                          { staticClass: "white--text", attrs: { left: "" } },
                          [_vm._v(_vm._s(item.icon))]
                        ),
                        _vm._v(_vm._s(item.text)),
                      ],
                      1
                    )
                  }),
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "cover",
            fn: function () {
              return [
                _c(
                  "v-card",
                  {
                    staticClass: "lesson-detail-card half-round w-full",
                    attrs: { light: "" },
                  },
                  [
                    _c(
                      "v-container",
                      { ref: "lessonDetailContainer" },
                      [
                        _c(
                          "div",
                          { staticClass: "flex w-full justify-center" },
                          [
                            _c("div", {
                              staticClass: "drag-handle",
                              on: {
                                mousedown: function ($event) {
                                  return _setup.overflow()
                                },
                                touchstart: function ($event) {
                                  return _setup.overflow()
                                },
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _setup.loading
                          ? _c("v-skeleton-loader", {
                              staticClass: "mx-auto my-5",
                              attrs: {
                                "max-width": "300",
                                type: "list-item-avatar, list-item, list-item",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        !_setup.loading
                          ? _c(_setup.LessonDetailActions, {
                              attrs: {
                                auth: _vm.auth,
                                lesson: _setup.lesson,
                                billingUser: _setup.billingUser,
                                purchaseOption: _setup.getPurchaseOption,
                                paymentStatus: _setup.getPaymentStatus,
                              },
                              on: {
                                success: function ($event) {
                                  return _setup.handleSuccess(true)
                                },
                                rescheduleLesson: function ($event) {
                                  return _setup.emit("rescheduleLesson", $event)
                                },
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        !_setup.loading || _setup.lesson.id
                          ? _c(
                              "v-list",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_setup.loading,
                                    expression: "!loading",
                                  },
                                ],
                                ref: "lessonDetailList",
                                staticClass: "divide-y",
                              },
                              [
                                !_setup.lesson.group_event &&
                                _setup.lesson.student
                                  ? _c(_setup.LessonDetailUser, {
                                      attrs: {
                                        user: _setup.lesson.student,
                                        billingUser: _setup.billingUser,
                                        large: "",
                                        title: "Student",
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                !!_setup.lesson.group_event
                                  ? _c(_setup.LessonDetailEnrollment, {
                                      attrs: { lesson: _setup.lesson },
                                      on: {
                                        success: function ($event) {
                                          return _setup.handleSuccess()
                                        },
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                !_setup.lesson.group_event &&
                                _setup.lesson.student
                                  ? _c(_setup.LessonDetailPurchaseOption, {
                                      attrs: {
                                        purchaseOption:
                                          _setup.lesson.student.attendance
                                            .purchase_option,
                                        paymentStatus: _setup.getPaymentStatus,
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(_setup.LessonDetailUser, {
                                  attrs: {
                                    user: _setup.lesson.teacher,
                                    title: "Teacher",
                                  },
                                }),
                                _vm._v(" "),
                                _setup.lesson.notes
                                  ? _c(_setup.LessonDetailNote, {
                                      attrs: {
                                        content: _setup.lesson.notes,
                                        title: _setup.lesson.student
                                          ? `About ${_setup.lesson.student.first_name}`
                                          : "Notes",
                                        hold: _setup.lesson.type === "Hold",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return [
                !_setup.loading && _setup.lesson.type !== "Hold"
                  ? _c("SoliAttendance", {
                      attrs: {
                        event: _setup.lesson,
                        eventId: _vm.lessonId,
                        studentId: _setup.lesson.student?.id,
                        groupEvent: !!_setup.lesson.group_event,
                        groupStatus:
                          _setup.lesson.group_event && _setup.lesson.cancelled
                            ? "Teacher-cancel"
                            : null,
                        errors: _vm.errors,
                      },
                      on: {
                        showStudentList: function ($event) {
                          _setup.showAttendanceList = true
                        },
                        refresh: function ($event) {
                          return _setup.refreshNotes($event)
                        },
                        success: function ($event) {
                          return _setup.handleSuccess(
                            $event ?? !_setup.lesson.group_event
                          )
                        },
                      },
                    })
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _setup.showAttendanceList
        ? _c(_setup.LessonDetailAttendanceList, {
            attrs: { lesson: _setup.lesson, subMenuModal: "" },
            on: {
              showMessage: function ($event) {
                return _setup.emit("showMessage", 300)
              },
              refresh: function ($event) {
                return _setup.fetchLesson(true)
              },
              reset: function ($event) {
                _setup.showAttendanceList = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }